(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const styleId = 'nd-contact-form-layout';
    const enhanceForm = (embed) => {
      const root = embed.shadowRoot;
      if (!root || root.getElementById(styleId)) return Boolean(root);

      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        [role="dialog"] {
          --container-max-w: none;
          --inline-container-max-width: none;
          width: 100% !important;
          max-width: none !important;
          padding: 0 !important;
          background: #fff !important;
        }
        [role="dialog"] h2 {
          margin: 0 0 .5rem !important;
          font-family: "Tenor Sans", sans-serif !important;
          font-size: clamp(24px, 1.7vw, 28px) !important;
          font-weight: 400 !important;
          letter-spacing: -.035em !important;
          line-height: 1.05 !important;
        }
        [role="dialog"] h2 + p {
          margin: 0 0 1.6rem !important;
          color: #707070 !important;
          font-family: "Poppins", sans-serif !important;
          font-size: 12px !important;
          line-height: 1.5 !important;
        }
        form[data-testid="form"] {
          display: grid !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          gap: .85rem 1rem !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
          padding: 0 !important;
        }
        form[data-testid="form"] > * {
          min-width: 0 !important;
        }
        form[data-testid="form"] > div:first-child {
          display: none !important;
        }
        form[data-testid="form"] > :has(#first_name) {
          grid-column: 1 !important;
          grid-row: 1 !important;
        }
        form[data-testid="form"] > :has(#last_name) {
          grid-column: 2 !important;
          grid-row: 1 !important;
        }
        form[data-testid="form"] > :has(#email) {
          grid-column: 1 !important;
          grid-row: 2 !important;
        }
        form[data-testid="form"] > :has(#phone_number) {
          grid-column: 2 !important;
          grid-row: 2 !important;
        }
        form[data-testid="form"] > :has(#emailConsent-true) {
          grid-column: 1 / -1 !important;
          grid-row: 5 !important;
          margin: .3rem 0 0 !important;
        }
        form[data-testid="form"] > :has(input[type="file"]) {
          align-self: end !important;
          grid-column: 1 !important;
          grid-row: 4 !important;
          max-width: none !important;
        }
        form[data-testid="form"] > :has(textarea) {
          grid-column: 1 / -1 !important;
          grid-row: 3 !important;
        }
        form[data-testid="form"] > button[type="submit"] {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          grid-column: 2 !important;
          grid-row: 4 !important;
          justify-self: stretch !important;
          align-self: end !important;
          width: 100% !important;
          min-width: 0 !important;
          min-height: 52px !important;
          box-sizing: border-box !important;
          margin: 0 !important;
          padding: 0 2rem !important;
          border-radius: 999px !important;
          font-family: "Poppins", sans-serif !important;
          font-size: 12px !important;
          line-height: 1.2 !important;
          letter-spacing: .02em !important;
          overflow: hidden !important;
        }
        [role="dialog"] form[data-testid="form"] + div {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          box-sizing: border-box !important;
          overflow: visible !important;
        }
        [role="dialog"] form[data-testid="form"] + div p {
          width: 100% !important;
          max-width: 100% !important;
          margin: 0 !important;
          overflow-wrap: anywhere !important;
          white-space: normal !important;
        }
        input:not([type="checkbox"]):not([type="radio"]), textarea {
          height: 54px !important;
          min-height: 52px !important;
          padding-block: 0 !important;
          box-sizing: border-box !important;
          border: 1px solid #d8d8d5 !important;
          border-radius: 10px !important;
          background: #fff !important;
          color: #26231f !important;
          font-family: "Poppins", sans-serif !important;
          font-size: 13px !important;
          box-shadow: none !important;
          outline: 0 solid transparent !important;
        }
        textarea {
          height: 116px !important;
          min-height: 116px !important;
          padding-block: .9rem !important;
          resize: vertical !important;
        }
        input::placeholder,
        textarea::placeholder {
          color: #8a8a86 !important;
          font-family: "Poppins", sans-serif !important;
          font-size: 13px !important;
          font-weight: 400 !important;
          opacity: 1 !important;
        }
        #phone_number {
          padding-top: 17px !important;
          padding-bottom: 3px !important;
          font-size: 13px !important;
          line-height: 1.2 !important;
        }
        #label-phone_number {
          top: 10px !important;
          color: #8a8a86 !important;
          font-family: "Poppins", sans-serif !important;
          font-size: 10px !important;
          line-height: 1 !important;
          transform: none !important;
        }
        form[data-testid="form"] > :has(textarea)::before {
          content: none !important;
          display: none !important;
        }
        form[data-testid="form"] > :has(#phone_number) button {
          height: 54px !important;
          min-height: 54px !important;
          box-sizing: border-box !important;
          border: 1px solid #d8d8d5 !important;
          border-radius: 10px !important;
          box-shadow: none !important;
        }
        form[data-testid="form"] > :has(input[type="file"]) > div:last-child {
          height: 58px !important;
          min-height: 58px !important;
          border: 1px dashed #c9c9c5 !important;
          border-radius: 10px !important;
          background: #fbfbfa !important;
          box-shadow: none !important;
        }
        form[data-testid="form"] > :has(input[type="file"]) p {
          margin-bottom: .4rem !important;
          color: #707070 !important;
          font-size: 11px !important;
        }
        form[data-testid="form"] > :has(input[type="file"]) span {
          font-family: "Poppins", sans-serif !important;
          font-size: 11px !important;
        }
        input[type="checkbox"] {
          width: 18px !important;
          min-width: 18px !important;
          height: 18px !important;
          min-height: 18px !important;
          border-radius: 3px !important;
        }
        label, p, button {
          font-family: "Poppins", sans-serif !important;
        }
        label:has(#emailConsent-true) {
          color: #5f5f5f !important;
          font-size: 11px !important;
          line-height: 1.5 !important;
        }
        input:focus-visible, textarea:focus-visible, button:focus-visible {
          outline: 2px solid #26231f !important;
          outline-offset: 2px !important;
        }
        @media (max-width: 749px) {
          [role="dialog"] h2 { font-size: 24px !important; }
          [role="dialog"] h2 + p { margin-bottom: 1.6rem !important; }
          form[data-testid="form"] { grid-template-columns: minmax(0, 1fr) !important; gap: .75rem !important; }
          form[data-testid="form"] > *,
          form[data-testid="form"] > button[type="submit"] {
            grid-column: 1 !important;
          }
          form[data-testid="form"] > :has(#first_name) { grid-row: 1 !important; }
          form[data-testid="form"] > :has(#last_name) { grid-row: 2 !important; }
          form[data-testid="form"] > :has(#email) { grid-row: 3 !important; }
          form[data-testid="form"] > :has(#phone_number) { grid-row: 4 !important; }
          form[data-testid="form"] > :has(textarea) { grid-row: 5 !important; }
          form[data-testid="form"] > :has(input[type="file"]) { grid-row: 6 !important; }
          form[data-testid="form"] > button[type="submit"] { grid-row: 7 !important; }
          form[data-testid="form"] > :has(#emailConsent-true) { grid-row: 8 !important; }
          form[data-testid="form"] > button[type="submit"] {
            width: 100% !important;
            min-width: 0 !important;
          }
          form[data-testid="form"] > :has(input[type="file"]) {
            max-width: none !important;
          }
          input:not([type="checkbox"]):not([type="radio"]),
          textarea,
          input::placeholder,
          textarea::placeholder { font-size: 16px !important; }
          #phone_number { font-size: 16px !important; }
        }
      `;
      root.appendChild(style);
      return true;
    };

    const enhanceAll = () => {
      document.querySelectorAll('.nd-contact-form-app shopify-forms-embed').forEach(enhanceForm);
    };

    enhanceAll();
    const observer = new MutationObserver(enhanceAll);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-product-detail"] && !Shopify.designMode) return;
  try {
    
  const ndSelectProductMedia = (section, mediaId) => {
    const selectedPanel = section.querySelector(`[data-nd-product-media="${mediaId}"]`);
    if (!selectedPanel) return;

    section.querySelectorAll('[data-nd-product-thumbnail]').forEach((button) => {
      const isSelected = button.dataset.ndProductThumbnail === mediaId;
      button.classList.toggle('is-active', isSelected);
      button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      if (isSelected) button.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });

    section.querySelectorAll('[data-nd-product-media]').forEach((panel) => {
      const isSelected = panel === selectedPanel;
      panel.classList.toggle('is-active', isSelected);
      panel.hidden = !isSelected;
    });
  };

  const ndShowLightboxMedia = (dialog, mediaId) => {
    const panels = [...dialog.querySelectorAll('[data-nd-lightbox-panel]')];
    const requested = panels.find((panel) => panel.dataset.ndLightboxPanel === mediaId) || panels[0];
    panels.forEach((panel) => { panel.hidden = panel !== requested; });
  };

  const ndStepProductMedia = (section, direction) => {
    const panels = [...section.querySelectorAll('[data-nd-product-media]')];
    const currentIndex = panels.findIndex((panel) => panel.classList.contains('is-active'));
    if (currentIndex < 0 || panels.length < 2) return;
    const nextIndex = (currentIndex + direction + panels.length) % panels.length;
    ndSelectProductMedia(section, panels[nextIndex].dataset.ndProductMedia);
  };

  const ndStepLightbox = (dialog, direction) => {
    const panels = [...dialog.querySelectorAll('[data-nd-lightbox-panel]')];
    const currentIndex = panels.findIndex((panel) => !panel.hidden);
    if (currentIndex < 0 || panels.length < 2) return;
    const nextIndex = (currentIndex + direction + panels.length) % panels.length;
    panels.forEach((panel, index) => { panel.hidden = index !== nextIndex; });
  };

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-nd-product-thumbnail]');
    if (thumbnail) {
      const section = thumbnail.closest('.nd-product');
      if (section) ndSelectProductMedia(section, thumbnail.dataset.ndProductThumbnail);
      return;
    }

    const scrollButton = event.target.closest('[data-nd-thumb-scroll]');
    if (scrollButton) {
      const rail = scrollButton.closest('.nd-product__thumbnail-rail');
      const thumbnails = rail && rail.querySelector('.nd-product__thumbnails');
      if (thumbnails) thumbnails.scrollBy({ top: Number(scrollButton.dataset.ndThumbScroll) * thumbnails.clientHeight * .72, behavior: 'smooth' });
      return;
    }

    const section = event.target.closest('.nd-product');
    if (!section) return;
    const dialog = section.querySelector('[data-nd-lightbox]');

    const mediaStep = event.target.closest('[data-nd-media-step]');
    if (mediaStep) {
      ndStepProductMedia(section, Number(mediaStep.dataset.ndMediaStep));
      return;
    }

    if (event.target.closest('[data-nd-lightbox-open]') && dialog) {
      const activeMedia = section.querySelector('[data-nd-product-media].is-active');
      ndShowLightboxMedia(dialog, activeMedia && activeMedia.dataset.ndProductMedia);
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      return;
    }

    if (event.target.closest('[data-nd-lightbox-close]') && dialog) dialog.close();
    if (event.target.closest('[data-nd-lightbox-prev]') && dialog) ndStepLightbox(dialog, -1);
    if (event.target.closest('[data-nd-lightbox-next]') && dialog) ndStepLightbox(dialog, 1);
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-nd-lightbox]')) document.documentElement.style.overflow = '';
  }, true);

  document.addEventListener('keydown', (event) => {
    const dialog = document.querySelector('[data-nd-lightbox][open]');
    if (!dialog) return;
    if (event.key === 'ArrowLeft') ndStepLightbox(dialog, -1);
    if (event.key === 'ArrowRight') ndStepLightbox(dialog, 1);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-project-grid"] && !Shopify.designMode) return;
  try {
    
  const initialiseTestimonialCarousel = (carousel) => {
    if (carousel.dataset.ndInitialised === 'true') return;

    const track = carousel.querySelector('[data-nd-testimonials-track]');
    const previous = carousel.querySelector('[data-nd-testimonials-prev]');
    const next = carousel.querySelector('[data-nd-testimonials-next]');
    if (!track || !previous || !next) return;

    const move = (direction) => {
      const testimonial = track.querySelector('.nd-grid__testimonial');
      if (!testimonial) return;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({
        left: direction * (testimonial.getBoundingClientRect().width + gap),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    carousel.dataset.ndInitialised = 'true';
  };

  const initialiseTestimonialCarousels = (root = document) => {
    root.querySelectorAll('[data-nd-testimonials]').forEach(initialiseTestimonialCarousel);
  };

  initialiseTestimonialCarousels();
  document.addEventListener('shopify:section:load', (event) => initialiseTestimonialCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["native-project-legacy"] && !Shopify.designMode) return;
  try {
    
  const ndShowProjectLightboxImage = (dialog, imageId) => {
    const panels = [...dialog.querySelectorAll('[data-nd-project-lightbox-panel]')];
    const requestedPanel = panels.find((panel) => panel.dataset.ndProjectLightboxPanel === imageId) || panels[0];
    panels.forEach((panel) => { panel.hidden = panel !== requestedPanel; });
  };

  const ndStepProjectLightbox = (dialog, direction) => {
    const panels = [...dialog.querySelectorAll('[data-nd-project-lightbox-panel]')];
    const currentIndex = panels.findIndex((panel) => !panel.hidden);
    if (currentIndex < 0 || panels.length < 2) return;
    const nextIndex = (currentIndex + direction + panels.length) % panels.length;
    panels.forEach((panel, index) => { panel.hidden = index !== nextIndex; });
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-nd-project-lightbox-open]');
    if (openButton) {
      const project = openButton.closest('.nd-legacy-project');
      const dialog = project && project.querySelector('[data-nd-project-lightbox]');
      if (!dialog) return;
      ndShowProjectLightboxImage(dialog, openButton.dataset.ndProjectLightboxOpen);
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      return;
    }

    const dialog = event.target.closest('[data-nd-project-lightbox]');
    if (!dialog) return;
    if (event.target.closest('[data-nd-project-lightbox-close]')) dialog.close();
    if (event.target.closest('[data-nd-project-lightbox-prev]')) ndStepProjectLightbox(dialog, -1);
    if (event.target.closest('[data-nd-project-lightbox-next]')) ndStepProjectLightbox(dialog, 1);
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-nd-project-lightbox]')) document.documentElement.style.overflow = '';
  }, true);

  document.addEventListener('keydown', (event) => {
    const dialog = document.querySelector('[data-nd-project-lightbox][open]');
    if (!dialog) return;
    if (event.key === 'ArrowLeft') ndStepProjectLightbox(dialog, -1);
    if (event.key === 'ArrowRight') ndStepProjectLightbox(dialog, 1);
  });

  } catch(e) { console.error(e); }
})();
})();
